import * as React from 'react';
import styled from 'styled-components';
import cx from 'classnames';
import SvgIcon from 'root/components/SvgIcon';
import queueConsts from '../../data/consts';
import SVG_ICONS from '~/assets/icons/icons';

const { STATUSES } = queueConsts;

const GAction = styled.div.attrs({
  className: cx('EXPANDED_ITEM--ASSET_ACTION', 'absolute w-100 h-100 top-0 left-0', 'flex items-center justify-center'),
})``;

const GButton = styled.div.attrs({ className: 'flex items-center justify-center pointer' })({
  boxShadow: '0 2px 4px 0 rgba(0,0,0,0.5)',
  backgroundColor: 'rgba(0,0,0,0.6)',
  padding: '10px 14px',
  borderRadius: 5,
});

const AssetAction = ({ status, onRetry, onAbort }) => (
  <GAction>
    {(status === STATUSES.ERROR || status === STATUSES.ABORTED) && (
      <GButton data-test="asset-action-retry" onClick={(...args) => onRetry(...args)}>
        <SvgIcon path={SVG_ICONS.RETRY} size={20} color="#FFFFFF" />
      </GButton>
    )}

    {status === STATUSES.UPLOADING && (
      <GButton onClick={onAbort} data-test="asset-action-abort">
        <SvgIcon path={SVG_ICONS.PAUSE} size={28} color="#FFFFFF" />
      </GButton>
    )}
  </GAction>
);

export default AssetAction;
